<template>
  <div class="ProcessMenu">
      <FormMenu />
      <ValidationObserver ref="obsFieldsUpdate">
        <FormMenu
          :FieldsForm="formUpdate"
          :ModelForm="formUpdModel"
          :method="executeProcess"
        />
      </ValidationObserver>
  </div>
</template>

<script>
import IberoHelpers from '@/store/helpers.js'
import FormMenu from '@/components/forms/Forms.vue'

export default {
  name: 'ProcessMenu',
  props: {
    IdForm: String,
    labelAction: String,
    ModelForm: Object,
    method: Function,
  },
  data () {
    return {
      formUpdModel: {
        IdId_Menu: 0,
        IdNam_Menu: '',
        IdId_MenuRoot: 0,
        IdDes_MenuRoot: '',
        IdNam_Icon: '',
        IdDes_Detail: '',
        IdDes_Image: '',
        IdDes_Target: '',
      },
      formUpdate: [
        {
          id: 'IdNam_Menu',
          model: 'IdNam_Menu',
          name: 'Etiqueta',
          type: 'input',
          placeholder: 'Etiqueta',
          values: '',
          validate: {
            required: true,
          },
          class: 'col-md-6',
        },
        {
          id: 'IdDes_MenuRoot',
          model: 'IdDes_MenuRoot',
          name: 'Link',
          type: 'input',
          placeholder: 'Link',
          values: '',
          validate: {
            required: true,
          },
          class: 'col-md-6',
        },
        {
          id: 'IdNam_Icon',
          model: 'IdNam_Icon',
          name: 'Icono',
          type: 'input',
          placeholder: 'Icono',
          values: '',
          validate: {
            required: true,
          },
          class: 'col-md-6',
        },
        {
          id: 'IdDes_Detail',
          model: 'IdDes_Detail',
          name: 'Detalle',
          type: 'input',
          placeholder: 'Detalle',
          values: '',
          validate: {
            required: false,
          },
          class: 'col-md-6',
        },
        {
          id: 'IdDes_Image',
          model: 'IdDes_Image',
          name: 'Imagen',
          type: 'input',
          placeholder: 'Imagen',
          values: '',
          validate: {
            required: false,
          },
          class: 'col-md-12',
        },
        {
          id: 'IdDes_Target',
          model: 'IdDes_Target',
          name: 'Target',
          type: 'input',
          placeholder: 'Target',
          values: '',
          validate: {
            required: false,
          },
          class: 'col-md-6',
        },
        {
          type: 'ClearZone',
          class: 'col-md-2',
        },
        {
          id: 'Upt_Button',
          type: 'button',
          placeholder: this.labelAction,
          class: 'col-md-4',
        },
      ],
    }
  },
  components: {
    FormMenu,
  },
  created () {
    this.loadModelData()
  },
  methods: {
    loadModelData () {
      if (!(typeof this.ModelForm === 'undefined')) {
        this.formUpdModel.IdId_Menu = this.ModelForm.Id_Menu
        this.formUpdModel.IdNam_Menu = this.ModelForm.Nam_Menu
        this.formUpdModel.IdDes_MenuRoot = this.ModelForm.Des_MenuRoot
        this.formUpdModel.IdNam_Icon = this.ModelForm.Nam_Icon
        this.formUpdModel.IdDes_Detail = this.ModelForm.Des_Detail
        this.formUpdModel.IdDes_Image = this.ModelForm.Des_Image
        this.formUpdModel.IdDes_Target = this.ModelForm.Des_Target
      } else if (!(typeof this.IdForm === 'undefined')) {
        this.formUpdModel.IdId_MenuRoot = this.IdForm
      }
    },
    MenuProcess () {
      let loader = this.$loading.show()
      var referenceVal = (this.formUpdModel.IdId_Menu === 0) ? 0 : 5
      var ProcessMenu = IberoHelpers.updateMenu(this.$store, this.formUpdModel, referenceVal)
      ProcessMenu.then(Response => {
        if (Response.data) {
          if (Response.data.message === 'Success') {
            this.method()
          } else {
            loader.hide()
          }
        } else {
          loader.hide()
        }
      })
    },
    executeProcess: function (event, refer) {
      switch (event.target.id) {
        case 'btn_Upt_Button':
          return new Promise((resolve, reject) => {
            this.$refs.obsFieldsUpdate.validate().then(results => {
              if (!results) {
                resolve(false)
              } else {
                this.MenuProcess()
                resolve(true)
              }
            })
          })
      }
    },
  },
}
</script>

<style scoped>
.ProcessMenu {
  padding: 10px;
}
</style>